import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRepair = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_live_map_repair)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 34,
					height: 34,
					rx: 17,
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 1,
					y: 1,
					width: 32,
					height: 32,
					rx: 16,
					stroke: "white",
					strokeWidth: 2
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M25.8982 10.9154C26.1105 10.9727 26.3039 11.0849 26.459 11.2406C26.6141 11.3964 26.7253 11.5903 26.7814 11.8027C27.3469 13.9397 26.8215 16.3267 25.13 18.0139C24.3472 18.7977 23.3748 19.3661 22.3073 19.6639C21.2398 19.9617 20.1133 19.9788 19.0372 19.7135C18.9768 19.6975 18.9136 19.6949 18.852 19.706L18.8208 19.716L12.4652 26.0647C11.8641 26.6637 11.0498 27 10.2008 27C9.35175 27 8.53739 26.6637 7.93628 26.0647C7.33671 25.4643 7 24.6508 7 23.8027C7 22.9546 7.33671 22.1411 7.93628 21.5407L14.2918 15.192L14.3018 15.1607C14.313 15.0993 14.3104 15.0361 14.2943 14.9758C14.0299 13.8982 14.0483 12.7708 14.3477 11.7024C14.6471 10.634 15.2173 9.66089 16.0033 8.87704C16.8013 8.07761 17.7971 7.50377 18.8894 7.21398C19.9817 6.9242 21.1313 6.92882 22.2212 7.22738C22.434 7.28345 22.6281 7.39457 22.7842 7.54953C22.9402 7.70449 23.0525 7.89781 23.1099 8.10999C23.1672 8.32217 23.1676 8.54571 23.1108 8.75805C23.0541 8.9704 22.9423 9.16404 22.7867 9.31945L20.1594 11.9439L20.6386 13.3811L22.0774 13.8598L24.7046 11.2353C24.8603 11.0799 25.0542 10.9683 25.2668 10.9117C25.4795 10.8551 25.7033 10.8555 25.9157 10.9129L25.8982 10.9154ZM24.2342 17.1391C23.602 17.7709 22.8174 18.2293 21.9562 18.4701C21.095 18.7109 20.1862 18.7259 19.3174 18.5138C18.822 18.3938 18.2828 18.485 17.9162 18.845L11.5607 25.1937C10.8013 25.9535 9.55895 25.9535 8.79578 25.1937C8.43135 24.8262 8.2269 24.3299 8.2269 23.8127C8.2269 23.2955 8.43135 22.7992 8.79578 22.4317L15.1513 16.083C15.5116 15.7231 15.603 15.182 15.4829 14.6833C15.306 13.9542 15.2876 13.1956 15.4291 12.4588C15.6286 11.4422 16.1249 10.5073 16.8553 9.77186C17.8061 8.82205 19.0322 8.32216 20.2708 8.27217C20.8102 8.24865 21.35 8.30636 21.8722 8.44338L19.2449 11.0678C19.0813 11.2315 18.9663 11.4373 18.9129 11.6624C18.8594 11.8875 18.8695 12.1229 18.9421 12.3426L19.4213 13.7798C19.5464 14.1534 19.8392 14.4459 20.212 14.5696L21.6507 15.0483C21.8705 15.1222 22.1066 15.1331 22.3322 15.0796C22.5577 15.0261 22.7638 14.9105 22.9268 14.7458L25.5541 12.1214C25.6918 12.6438 25.7493 13.1824 25.7255 13.721C25.6715 15.0062 25.1356 16.2241 24.2242 17.1328L24.2342 17.1391Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_live_map_repair",
			x: 0,
			y: 0,
			width: 37.4,
			height: 37.4,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 2,
					dy: 2
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .7 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_live_map_repair"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_live_map_repair",
					result: "shape"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgRepair);
export { ForwardRef as ReactComponent };
